<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div>
        <div v-if="isFieldVisible('city_id')" class="row">
    
          <div class="form-group bordered col-md-4 mt-3">
           
            <label for="countries" class="form-label text-left">País</label>
            <SelectCountries 
            :data="countries" 
            v-bind:selectedCountrie="selectedCountries" 
            v-on:update:selectedCountrie="selectedCountries = $event"
            @change="emitFieldChanged('countries')"
            required="required"
            >
            </SelectCountries>
          </div>
  
          <div class="form-group bordered col-md-4 mt-3">
            <!-- PROVINCIA -->
            <label for="states" class="form-label text-left">Provincia</label>
            <SelectStates
            :data="states" 
            v-bind:selectedState="selectedStates" 
            v-on:update:selectedState="selectedStates = $event"
            @change="emitFieldChanged('states')"
            required="required"
            >
          </SelectStates>
          </div>
  
          <div class="form-group bordered col-md-4 mt-3">
            <!-- CIUDAD -->
            <label for="cities" class="form-label text-left">Ciudad</label>
            <SelectCities
            :data="cities" 
            v-bind:selectedCitie="selectedCities" 
            v-on:update:selectedCitie="selectedCities = $event"
            @change="emitFieldChanged('cities')"
            required="required"
            >
            </SelectCities>
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, watch, watchEffect } from 'vue'
  import SelectCountries from './selectDatos/SelectCountries'
  import SelectCities from './selectDatos/SelectCities'
  import SelectStates from './selectDatos/SelectStates'
  import apiCities from '../../../apis/Cities'
  import {
    selectCountries,
    selectCities,
    selectStates,
  } from '../../../Utils/apiCitiesSelectorHelpers'

  export default {
    name: 'FormCities&Country',
    props: {
      data: Object,
    },
    components: {
      SelectCountries,
      SelectCities,
      SelectStates,
    },
    emits: ['formDataChanged'],
    setup(props, { emit }) {
      const dataCompany = ref(props.data.dataCompaniesForms);
      const countries = ref([]);
      const states = ref([]);
      const cities = ref([]);
      const showComponentData = ref(false);
      const selectedCountries = ref('');
      const selectedCities = ref('');
      const selectedStates = ref('');

      const formData = ref({
        city_id: selectedCities.value,
      });

      const cargarDatos = async () => {
        try {
          showComponentData.value = (dataCompany.value && dataCompany.value.city_id);
          countries.value = await selectCountries();
          states.value = await selectStates();

        } catch (error) {
          console.error(error);
        }
      };

      const isFieldVisible = (fieldName) => {
        return dataCompany.value && dataCompany.value[fieldName] === 1;
      };
      
      const getCities = async (newState) => {
        try {
          const newStateId = {
            stateId: newState,
          };
          const response = await apiCities.postCities(newStateId);
          cities.value = response.data;
        } catch (error) {
          console.error(error);
        }
      };

      const emitFieldChanged = () => {
        formData.value.city_id = selectedCities.value;
        emit('formDataChanged',  formData.value);
      };

      watch(selectedStates, (newState) => {
        getCities(newState);
      });

      watchEffect(() => {
        if (selectedCities.value !== formData.value.city_id) {
          emitFieldChanged();
        }
      });

      onMounted(cargarDatos);

      return {
        dataCompany,
        countries,
        cities,
        states,
        selectedCountries,
        selectedCities,
        selectedStates,
        getCities,
        isFieldVisible,
        formData,
        emitFieldChanged,
        showComponentData,
      };
    },
  };
</script>
